import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function AntibodyFeedbackBanner(): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.BETA}
      hideIcon={true}
      supportingInfo={
        <>
          Antibodies are a new beta feature. Please{' '}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScNEUhMYT1rA7wcXGPutNV9uBdFYB1lJ8rGiEGiqBPoHiN1Gw/viewform"
            target="_blank"
            rel="noreferrer"
          >
            let us know what you think
          </a>
          .
        </>
      }
    />
  );
}
